import { getPolicyTypeById } from "@/api/policy-types";
import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { LinkedSkillSection } from "@/components/admin/LinkedSkillSection";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { PolicyTypeInfoSection } from "./components/policy-type-details/PolicyTypeInfoSection";

const AdminPolicyTypeDetails = () => {
    const { policyTypeId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Policy Type");

    const { data: policyType } = useSuspenseQuery({
        queryKey: ["admin-policy-type-details", policyTypeId],
        queryFn: () => getPolicyTypeById(Number(policyTypeId)),
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Policy Types", path: "policy-types" },
            { label: policyType.name },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title={policyType.name}
                subtitle="Policy type configuration and settings"
            />
            <Stack spacing={3} pb={2} className="mt-6">
                <PolicyTypeInfoSection policyType={policyType} />
                <LinkedSkillSection
                    entityId={policyType.id}
                    entityType="policy_type"
                    entityName={policyType.name}
                    skill={policyType.skill}
                    invalidateKeys={[
                        ["admin-policy-type-details", String(policyType.id)],
                        ["admin-policy-types"],
                    ]}
                />
            </Stack>
        </AdminPageContent>
    );
};

export default AdminPolicyTypeDetails;
